import { Maybe } from '@Types'
import { MailingAddressFormDefinition } from '@App/forms/common/mailing-address-form'

export const formatStreetAddress = (address: MailingAddressFormDefinition, withComma = true): Maybe<string> => {
    const { streetAddress, unitNumber, attention } = address
    let formattedStreetAddress = streetAddress
        ? unitNumber
            ? streetAddress + ', Unit ' + unitNumber
            : streetAddress
        : ''
    formattedStreetAddress = attention ? formattedStreetAddress + ' Attention: ' + attention : formattedStreetAddress
    return withComma && formattedStreetAddress ? formattedStreetAddress + ', ' : formattedStreetAddress
}

export const formatCityStateCode = (address: MailingAddressFormDefinition): Maybe<string> => {
    const { city, state, postalCode } = address
    return city && state && postalCode ? city + ', ' + state + ' ' + postalCode : ''
}
